//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'V326',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  }
};